import * as types from '../actions';
import { LIST_TYPE, ADD_TYPE, EDIT_TYPE, UPDATE_TYPE, DELETE_TYPE } from '../configs/staticConfigs';

const initialState = {
    rolesList: [],
    permissionsList: [],
    status:0,
    statusText: '',
    item:{
        id:'',
        name:''
    },
    activity:'',
    errorData:''    
};
export default function(state = initialState, action) {
    const response = action.response;
    switch(action.type) {

        case types.ROLES_LIST_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    rolesList: response.data.roles,
                    permissionsList: response.data.permissions,
                    status: response.status,
                    statusText: response.statusText, 
                    activity:LIST_TYPE
                };
            }
            else {
                return {
                    status: response.status,
                    statusText: response.statusText, 
                    activity:LIST_TYPE,
                    errorData: response.data,
                    ...state, response
                };
            }
        case types.ROLES_LIST_ERROR:
            return {
                status: response.status,
                statusText: response.statusText, 
                activity:LIST_TYPE,
                errorData: response.data,
                ...state, response
            };


        case types.ROLES_ADD_SUCCESS:  
            if(response.status===200 || response.status===201){
                let newRole = {
                    roleId: response.data.id,
                    roleName: response.data.name, 
                    permission: []
                }
                let wholeList = [...state.rolesList, newRole]; 
                return {
                    ...state,
                    roleList: wholeList,
                    status: response.status,
                    statusText: response.statusText, 
                    activity:ADD_TYPE
                }
            }
            else {
                return {
                    status: response.status,
                    statusText: response.statusText, 
                    activity:ADD_TYPE,
                    errorData: response.data,
                    ...state, response,
                }
            }
        case types.ROLES_ADD_ERROR:
            return { ...state, response,  errorData: response.data };   

        
        case types.ROLES_EDIT_SUCCESS: 
            if(response.status===200){         
                return {
                    ...state,
                    rolesData:{
                        id:response.data.id,
                        name: response.data.name
                    },
                    status: response.status,
                    statusText: response.statusText, 
                    activity:EDIT_TYPE             
                }
            }
            else {
                return {
                    ...state,
                    status: response.status,
                    statusText: response.statusText, 
                    activity:EDIT_TYPE,
                    errorData: response.data,             
                }
            }
        case types.ROLES_EDIT_ERROR:
            return { ...state, response,  errorData: response.data };


        case types.ROLES_UPDATE_SUCCESS:      
            if(response.status===200){      
                return {
                    ...state,
                    rolesData:{
                        id:response.data.id,
                        name: response.data.name
                    },
                    status: response.status,
                    statusText: response.statusText, 
                    activity:EDIT_TYPE            
                }
            }
            else {
                return {
                    ...state,
                    status: response.status,
                    statusText: response.statusText, 
                    activity:EDIT_TYPE,
                    errorData: response.data,              
                }
            }
        case types.ROLES_UPDATE_ERROR: 
            return { ...state, response,  errorData: response.data  };    


        case types.ROLES_DELETE_SUCCESS: 
            if(response.status===200){          
                return {
                    status: response.status,
                    statusText: response.statusText, 
                    activity: DELETE_TYPE 
                }
            }
            else {
                return {
                    status: response.status,
                    statusText: response.statusText, 
                    activity: DELETE_TYPE,
                    errorData: response.data, 
                }
            }
        case types.ROLES_DELETE_ERROR:  
            return { ...state, response,  errorData: response.data  }; 
             
        case types.ROLES_PERMISSION_UPDATE_SUCCESS: 
            if(response.status===200){  
                return {
                    ...state,
                    rolesData:{
                        id:response.data.id,
                        name: response.data.name
                    },
                    status: response.status,
                    statusText: response.statusText, 
                    activity:UPDATE_TYPE       
                }      
            }
            else {
                return {
                    ...state,
                    status: response.status,
                    statusText: response.statusText, 
                    activity:UPDATE_TYPE,
                    errorData: response.data      
                } 
            }     
        case types.ROLES_PERMISSION_UPDATE_ERROR:
            return { ...state, response,  errorData: response.data  };

            
        case types.CLEAR:
            return {
                ...state,
                item:{
                    id:'',
                    name: ''
                },
                activity:'',
                status:0,
                errorData: ''               
            }  


        default:
            return state;
    }
};

